// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exampleViewer {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  position: relative;
  overflow: hidden;
}

.nothingSelected {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 12pt;
  color: var(--color-black);
}

.exampleWrapper {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.panelGroup {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
}

.codeViewer {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
  min-height: 0;
  padding: 5px;
  overflow: hidden;
  background: #fff;
  border-radius: 3px;
}

body.theme-dark .codeViewer {
  background: #22262a;
}

.example {
  height: 100%;
  width: 100%;
  overflow: auto;
  position: relative;
  padding-right: 5px;
}

.spHeight {
  height: 100% !important;
  min-height: 0 !important;
}

.codeViewer .sp-wrapper,
.codeViewer .sp-layout {
  flex: 1 1 auto !important;
  min-height: 0 !important;
}

/* CodeMirror 6: keep editor within the panel and scroll inside the scroller */
.codeViewer .cm-editor {
  height: 100%;
  max-height: 100%;
}

.codeViewer .cm-scroller {
  overflow: auto !important;
}

body.theme-dark .spHeight {
  --sp-colors-surface1: #22262a !important;
  --sp-colors-surface2: #5c5c5c55 !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/ExampleViewer/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,8EAA8E;AAC9E;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C","sourcesContent":[".exampleViewer {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.nothingSelected {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  font-weight: 400;\n  font-size: 12pt;\n  color: var(--color-black);\n}\n\n.exampleWrapper {\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.panelGroup {\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  width: 100%;\n}\n\n.codeViewer {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  height: 100%;\n  min-height: 0;\n  padding: 5px;\n  overflow: hidden;\n  background: #fff;\n  border-radius: 3px;\n}\n\nbody.theme-dark .codeViewer {\n  background: #22262a;\n}\n\n.example {\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  position: relative;\n  padding-right: 5px;\n}\n\n.spHeight {\n  height: 100% !important;\n  min-height: 0 !important;\n}\n\n.codeViewer :global(.sp-wrapper),\n.codeViewer :global(.sp-layout) {\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n}\n\n/* CodeMirror 6: keep editor within the panel and scroll inside the scroller */\n.codeViewer :global(.cm-editor) {\n  height: 100%;\n  max-height: 100%;\n}\n\n.codeViewer :global(.cm-scroller) {\n  overflow: auto !important;\n}\n\nbody.theme-dark .spHeight {\n  --sp-colors-surface1: #22262a !important;\n  --sp-colors-surface2: #5c5c5c55 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"exampleViewer": `exampleViewer`,
	"nothingSelected": `nothingSelected`,
	"exampleWrapper": `exampleWrapper`,
	"panelGroup": `panelGroup`,
	"codeViewer": `codeViewer`,
	"themeDark": `theme-dark`,
	"example": `example`,
	"spHeight": `spHeight`
};
export default ___CSS_LOADER_EXPORT___;
